"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOrder = createOrder;
exports.getOrderInfo = getOrderInfo;
exports.getOrderPayInfo = getOrderPayInfo;
exports.productList = productList;
exports.submitOrder = submitOrder;

var _request = _interopRequireDefault(require("@/utils/request"));

// 获取商品列表
function productList(params) {
  return (0, _request.default)({
    url: '/performance/order/productList',
    method: 'get',
    params: params
  });
} // 创建订单


function createOrder(data) {
  return (0, _request.default)({
    url: '/performance/order/createOrder',
    method: 'post',
    data: data
  });
} // 提交订单


function submitOrder(data) {
  return (0, _request.default)({
    url: '/order/submitOrder',
    method: 'post',
    data: data
  });
} // 获取订单信息


function getOrderInfo(params) {
  return (0, _request.default)({
    url: '/order/getOrderInfo',
    method: 'get',
    params: params
  });
} // 获取订单支付信息


function getOrderPayInfo(params) {
  return (0, _request.default)({
    url: '/order/getOrderPayInfo',
    method: 'get',
    params: params
  });
}